import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClose = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		stroke: "currentColor",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M3.98008 8.223C3.04454 9.32718 2.3479 10.6132 1.93408 12C3.22608 16.338 7.24408 19.5 12.0001 19.5C12.9931 19.5 13.9531 19.362 14.8631 19.105M6.22808 6.228C7.94073 5.09786 9.94817 4.49688 12.0001 4.5C16.7561 4.5 20.7731 7.662 22.0651 11.998C21.357 14.3673 19.8371 16.4116 17.7721 17.772M6.22808 6.228L3.00008 3M6.22808 6.228L9.87808 9.878M17.7721 17.772L21.0001 21M17.7721 17.772L14.1221 14.122C14.4007 13.8434 14.6217 13.5127 14.7725 13.1486C14.9232 12.7846 15.0008 12.3945 15.0008 12.0005C15.0008 11.6065 14.9232 11.2164 14.7725 10.8524C14.6217 10.4883 14.4007 10.1576 14.1221 9.879C13.8435 9.6004 13.5127 9.3794 13.1487 9.22863C12.7847 9.07785 12.3946 9.00025 12.0006 9.00025C11.6066 9.00025 11.2164 9.07785 10.8524 9.22863C10.4884 9.3794 10.1577 9.6004 9.87908 9.879M14.1211 14.121L9.88008 9.88",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	})
});
const ForwardRef = forwardRef(SvgClose);
export default ForwardRef;
